import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type DepartmentState = {
  dataAllDepartment: DepartmentType[];
  dataAllUserInDepartment: UserInDepartmentType[];
  pagination: PaginationAPI;
  totalElements?: number;
  detailDepartment?: DetailDepartmentType;
};

export const departmentInitialState: DepartmentState = {
  dataAllDepartment: [],
  dataAllUserInDepartment: [],
  pagination: {
    pageNumber: Pagination.pageNumber,
    totalPages: 0,
    totalElements: 0,
    pageSize: Pagination.pageSize,
  },
};

export const slice = createSlice({
  name: 'department',
  initialState: departmentInitialState,
  reducers: {
    setListDepartmentAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: DepartmentType[];
        pagination?: PaginationAPI;
        totalElements?: number;
      }>,
    ) {
      state.dataAllDepartment = payload.data;
      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },

    setListUserInDepartmentAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: UserInDepartmentType[];
        pagination?: PaginationAPI;
        totalElements?: number;
      }>,
    ) {
      state.dataAllUserInDepartment = payload.data;
      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },

    addDepartmentAction(state, { payload }: PayloadAction<DepartmentType>) {
      state.dataAllDepartment = [payload, ...state.dataAllDepartment];
      state.pagination = {
        ...state.pagination,
        pageSize: state.pagination.pageSize + 1,
        totalElements: state.pagination.totalElements + 1,
      };
    },

    deleteDepartmentAction(state, { payload }: PayloadAction<string>) {
      state.dataAllDepartment = state.dataAllDepartment.filter(
        (item) => !payload.includes(item.id!),
      );
    },

    updateDepartmentAction(state, { payload }: PayloadAction<DepartmentType>) {
      state.dataAllDepartment = state.dataAllDepartment.map((item) => {
        if (item?.id === payload?.id) {
          return payload;
        }
        return item;
      });
    },
    setDetailDepartmentAction(
      state,
      { payload }: PayloadAction<{ detailDepartment: DetailDepartmentType }>,
    ) {
      state.detailDepartment = payload.detailDepartment;
    },
  },
});

export const {
  setListDepartmentAction,
  addDepartmentAction,
  deleteDepartmentAction,
  updateDepartmentAction,
  setDetailDepartmentAction,
  setListUserInDepartmentAction,
} = slice.actions;

export default slice.reducer;
